import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BomComponent, BomComponentCreate, BomComponentFilter } from '../data/bomComponent';

export function createBomComponentService(client: AxiosInstance) {
  return createCrudService<BomComponent, BomComponentCreate, BomComponentFilter>(
    client,
    '/manufacturing/BomComponent',
    'id',
  );
}

export type BomComponentService = CrudService<BomComponent, BomComponentCreate, BomComponentFilter>;
